export const premiumFeaturesContent = [
  {
    text: "- Neon Mech Design",
    badge: true
  },
  {
    text: "- Set Your Own Avatar",
    badge: true
  },
  {
    text: "- Limited Edition NFTs",
    badge: true
  },
  {
    text: "- Authentication Badge",
    badge: true
  },
  {
    text: "- Airdrop in the future",
    badge: true
  },
  {
    text: "- Premium Support (soon)",
    badge: true
  },
  {
    text: "- Other Benefits (TBD)",
    badge: true
  }
];